module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-betrekkelijk-voornaamwoord.json
// module id = 1298
// module chunks = 92992852587650